import React from "react";
import CusInput from "../../../mui/custom_input/CusInput";
import IconCard from "../../../mui/JSXIcons/IconCard";
import IconAddress from "../../../mui/JSXIcons/IconAddress";

export default function IFSCField() {
  return (
    <>
      <CusInput
        iconJSXstart={<IconCard />}
        name={"accNumber"}
        type={"number"}
        placeholder={"Account number"}
        title="Account number"
        required
      />
      <CusInput
        iconJSXstart={<IconAddress />}
        name={"IFSCcode"}
        placeholder={"IFSC code"}
        title={"IFSC code"}
        required
      />
    </>
  );
}
